<div class="dropdown-container" [ngClass]="{ open: dropdownShown }">
  <div class="input-container">
    <input
      type="text"
      readonly
      ngbTooltip="{{ selectedItemsDisplayValues }}"
      class="input border-grey-bluish-imp border-radius cursor-pointer font--xxl-13"
      appDebounce
      [(ngModel)]="selectedItemsPreview"
      (click)="openDropdownOnClickAndFocusSearchInput()"
      [inputVal]="selectedItemsPreview"
      [placeholder]="customPlaceholderText || 'Search here'"
    />
  </div>
  <div
    class="dropdown background-white border-grey-bluish-imp"
    *ngIf="dropdownShown"
    [style.height.rem]="(items.length + 1) * 2.5"
  >
    <div class="inner-search-container">
      <input
        #searchInput
        type="text"
        class="input input-search border-grey-bluish-imp border-radius"
        appDebounce
        [(ngModel)]="search"
        [inputVal]="search"
        (emitter)="onSearchChange()"
        [placeholder]="'Search here'"
      />
    </div>
    <div class="items">
      <div
        class="item font--xxl-13 font-500 color-body-text"
        *ngIf="dropdownShown && !items.length && !selectedItems.length"
      >
        No results
      </div>
      <div
        class="item cursor-pointer font--xxl-13 font-500 color-body-text"
        *ngFor="let item of selectedItems"
        (click)="unselectItem(item)"
      >
        {{ item[valueProperty] || 'not-entered' }}
      </div>
      <div
        class="item cursor-pointer font--xxl-13 font-regular color-body-text"
        *ngFor="let item of unselectedItems"
        (click)="selectItem(item)"
      >
        {{ item[valueProperty] || 'not-entered' }}
      </div>
    </div>
  </div>
</div>
